import Element from '../ui/Element';
import mixin from '../privates/utils/mixin';
import HiddenCollapsedMixin from './mixins/HiddenCollapsedMixin';


/**
 * @mixin HiddenCollapsedElement
 * @summary Provides functionality for all elements that can be hidden or collapsed.
 * @mixes $w.Element
 * @mixes $w.HiddenCollapsedMixin
 * @memberof $w
 */
class HiddenCollapsedElement extends Element {}

mixin(HiddenCollapsedElement.prototype, HiddenCollapsedMixin.prototype);

export default HiddenCollapsedElement;
